<template>
  <div :class="['MenuSubitemCmp', { 'a-heading text-color-blue': lgAndUp }]">
    <template>
      <slot name="main-link" />
    </template>
    <template>
      <div class="subitem-image-wrapper d-none d-lg-block">
        <div class="container-fluid">
          <div class="row">
            <div class="col-3 offset-9 d-flex justify-content-center">
              <slot name="image" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { xsOnly, mdAndUp, mdAndDown, lgAndUp } from '@/helpers/breakpoints.js';
export default {
  name: 'MenuSubitemCmp',
  setup() {
    return { xsOnly, mdAndUp, mdAndDown, lgAndUp };
  },
};
</script>

<style lang="scss" scoped>
.MenuSubitemCmp {
  position: relative;

  ::v-deep a {
    padding: 11.5px 16px;
    background: transparent;
    font-weight: 400;
    transition: background 0.5s;
    //margin-top: 5px;
    position: relative;
    display: block;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include media-breakpoint-up(lg) {
      position: unset;
    }
  }

  .subitem-image-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    padding-top: 50px;
    .row {
      height: 100%;
      position: relative;
      & > * {
        height: 100%;
        position: relative;
        ::v-deep img {
          opacity: 0;
          max-height: 100%;
          position: relative;
          border-radius: 8px;
          object-fit: cover;
          width: 100%;
          transition: opacity 1s ease;
        }
      }
    }
    .container-fluid {
      padding: 32px !important;
      position: relative;
      height: 100%;
      width: 100%;
      @include media-breakpoint-up(xl) {
        padding: 40px !important;
      }
    }
  }
  ::v-deep a {
    svg {
      opacity: 0;
      transition: opacity 0.3s ease;
      width: 16px;
      height: 16px;
    }
  }
  ::v-deep a:hover,
  ::v-deep a.go-to-section,
  ::v-deep a:active,
  ::v-deep a:focus {
    background: $color-dark-blue;
    font-weight: 800;
    svg {
      opacity: 1;
    }
  }
  /* hover/focus su link dentro lo slot main-link */
  ::v-deep a:hover ~ .subitem-image-wrapper,
  ::v-deep a.go-to-section ~ .subitem-image-wrapper,
  ::v-deep a:focus-within ~ .subitem-image-wrapper {
    img {
      opacity: 1;
    }
  }

  @include media-breakpoint-up(lg) {
    position: unset;
    ::v-deep a {
      font-weight: 800 !important;
      transition: none;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      svg {
        height: 24px;
        width: 24px;
        margin-left: 15px;
      }
    }
    ::v-deep a:hover,
    ::v-deep a:active,
    ::v-deep a:focus {
      background: $color-blue-10;
      color: $color-blue;
      text-decoration: underline;
      font-weight: 800;
      svg {
        opacity: 1;
      }
    }
  }
}
</style>
